<template>
  <a-modal
    width="600px"
    title="验收任务"
    v-model:visible="visible"
  >
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="任务名称">
        {{ form.name }}
      </a-form-item>
      <a-form-item label="任务总量">
        {{ form.total }}
      </a-form-item>
      <a-form-item label="验收比例">
        <a-input-number
          v-model:value="form.percentage"
          :min="0"
          :max="1"
          :step="0.01"
          @change="form.acceptCount = parseInt(form.total * form.percentage)" />
      </a-form-item>
      <a-form-item label="验收数量">
        {{ form.acceptCount }}
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
// import { getDataByPage } from '@/api/dataItem'
import { getDatasetItem } from '@/api/dataSet'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    addition: {
      type: String,
      default: () => ''
    },
    dataset: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      form: {
        name: '',
        total: 20000,
        percentage: 0.1,
        acceptCount: 2000
      },
      page: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.getDataItems(1)
        this.form.name = this.currentItem.name
      })
    },
    getDataItems (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      const addition = this.addition
      getDatasetItem({
        datasetId: this.dataset.id,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }).then(res => {
        const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
        // this.total = res.total > params.pageSizeMax - 0 ? params.pageSizeMax - 0 : res.total
        this.form.total = res.total > params.pageSizeMax - 0 ? params.pageSizeMax - 0 : res.total
        this.form.acceptCount = parseInt(this.form.total * this.form.percentage)
      })
      /* getDataByPage({ ...this.page, ...params }).then(res => {
        const data = res.data.map.data
        this.form.total = data.total
        this.form.acceptCount = parseInt(this.form.total * this.form.percentage)
      }) */
    }
  }
}
</script>
<style lang="less">

</style>
